import AddressLookup from './AddressLookup';
export { getAppliedAddress } from './addressLookupService';

export default AddressLookup;
